import { render, staticRenderFns } from "./ApplyVatDialog.vue?vue&type=template&id=4e375e35"
import script from "./ApplyVatDialog.vue?vue&type=script&lang=js"
export * from "./ApplyVatDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports